import { useEffect, useState } from 'react';
import useToolbarSetter from '../../../hooks/Common/useToolbarSetter';
import getExternalLink, { ExternalLink } from '../../../web_api/methods/externalLinks/getExternalLink';
// import LocationsBakery from './LocationsBakery';
import LocationsBakeryBulk from './LocationsBakeryBulk';

export default function BakeryAnalytics() {
    const { setToolbar } = useToolbarSetter();
    const [externalLink, setExternalLink] = useState<ExternalLink>();

    const handleExternalLink = async () => {
        const response = await getExternalLink(window.location.pathname);
        setExternalLink(response);
    }

    useEffect(() => {
        setToolbar(
            'bakery',
            `Bakery - Analytics`
        )
        handleExternalLink();
    }, [])
    return (
        <div className="container">
            {externalLink &&
                <div className='btn btn-secondary d-flex flex-row align-items-center gap-2 m-5 mb-0' style={{ justifySelf: "end", width: 'fit-content' }} onClick={() => { window.open(externalLink.link, '_blank') }}>Power BI <i className='bi bi-box-arrow-up-right'></i></div>
            }
            <div className="d-flex flex-column flex-md-row">
                <div className="d-flex flex-row flex-md-column col-12">
                    <div className="p-3 p-md-1 p-lg-0 p-xl-5 pb-0">
                        <LocationsBakeryBulk />
                    </div>
                    {/* <div className="p-5">
                        <ChartsWidget3 className='' title={`Bakery - ${activeLocation.value} - ${bakeryDateFilter.date?.toLocaleString('en-US', {
                            weekday: 'long',
                            day: 'numeric',
                            month: 'short'
                        }).replace(/\//g, '-')}, ${bakeryHourFilter.hour}:00`} take={null} shelfStatus={shelfStatus!} />
                    </div> */}
                </div>
            </div>
        </div>
    )
}
